const GOOGLE_TRACKING_SEARCH_PARAM = '_gl'

export function getGoogleSearchParam() {
  const searchParams = new URLSearchParams(window.location.search)
  const _glValue = searchParams.get(GOOGLE_TRACKING_SEARCH_PARAM)
  return _glValue && _glValue !== 'false' ? `_gl=${_glValue}` : ''
}
